import React, { memo } from "react";
// import component
import FormikContainer from "../../components/Formik/FormikContainer";
import DButton from "../../components/DButton";
import FieldContainer from "../../components/Formik/FieldContainer";
import { ErrorMessage, Form } from "formik";
import DCard from "../../components/DCard";
import { Spinner } from "@chakra-ui/react";
import DImage from "../DImage";
import ErrorMsg from "../Formik/Fields/ErrorMsg";

const PopupMessageForm = ({
  onSubmit,
  initialValues,
  validationSchema,
  btnText,
}) => {
  return (
    <DCard>
      <FormikContainer
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, isSubmitting, setFieldValue }) => (
          <Form>
            <div>
              <div className="grid sm:grid-cols-2 gap-4">
                <FieldContainer
                  name="title"
                  type="text"
                  label="العنوان"
                  id="title"
                />

                <FieldContainer
                  name="content"
                  type="text"
                  label="محتوى الرسالة "
                  id="content"
                />
                <FieldContainer
                  name="img_url"
                  type="text"
                  label="رابط الصورة"
                  id="img_url"
                />
              </div>
            </div>
            <DButton
              disabled={isSubmitting}
              type="submit"
              className="mx-auto min-w-[150px] rounded-lg  flex items-center justify-center text-white"
            >
              {isSubmitting ? <Spinner /> : btnText}
            </DButton>
          </Form>
        )}
      </FormikContainer>
    </DCard>
  );
};

export default memo(PopupMessageForm);
